import { get } from "src/services/api";

export const getMyPermissions = async () => {
  try {
    return await get({ endpoint: "/me/permissions" });
  } catch (error) {
    console.error("Error fetching baseline permissions", error);
    throw error;
  }
};

export const getAccountPermissions = async (accountId) => {
  try {
    return await get({ endpoint: `/accounts/${accountId}/me/permissions` });
  } catch (error) {
    console.error(`Error fetching permissions for account ${accountId}`, error);
    throw error;
  }
};
